import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const modalStyles = css`
	max-width: 1000px !important;
	font-size: 14px;

	.modal-content {
		max-height: 95vh;
	}

	.modal-body {
		overflow-y: auto;
	}
`;
